export const CASE_STUDY_CLIENT_URL = "https://ozexteriors.com.au/";

export const CASE_STUDY_STAMP_LABEL = "CASE STUDY";

export const CASE_STUDY_STAMP_META = "POST-DEPLOYMENT";

export const CASE_STUDY_HEADLINE_ACCENT = "+6 Additional Appointments";

export const CASE_STUDY_HEADLINE_LINE2 = "Per Week";

export const CASE_STUDY_LEAD = {
  beforeLink: "After connecting a digital employee, ",
  afterLink:
    " started booking six more qualified appointments on the calendar every week.",
};

export const CASE_STUDY_SIDEBAR_META =
  "Real company · Australia · Weekly uplift after go-live";

export const CASE_STUDY_METRICS = [
  {
    value: "+6",
    label: "Additional appointments per week",
    sub: "Started after digital employee went live",
    highlight: true,
  },
  {
    value: "9 sec",
    label: "Average Response time",
    sub: "vs 30-40 min office",
    highlight: false,
  },
  {
    value: "100%",
    label: "After-hours capture",
    sub: "Outside business hours",
    highlight: false,
  },
];

export const CASE_STUDY_CLIENT = {
  name: "Oz Exteriors",
};
